export default function() {
	let popupIsInited = false;

	window.ObserverUtil.observeRemove('plugin_arrived-popup', () => {
		popupIsInited = false;
	});

	window.ObserverUtil.observe('plugin_arrived-popup', function(node){
		if (popupIsInited) return false;
		popupIsInited = true;
		const wrapper = $(node);
		Update(wrapper.find('.formgroup'));
		Update(wrapper.find('.js-select-decorator'));
		Update(wrapper.find('.select'));
		wrapper.find('.plugin_arrived-submit').on('click', function() {
			wrapper.find('.plugin_arrived-form').submit();
		});
	});
}
